module.exports = __webpack_public_path__ + "static/media/Real-One-Specific.763bf945.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Real-One-Specific.otf
// module id = 3579
// module chunks = 71